import { Stack, Typography } from '@mui/material';
import { SuppliersContext } from 'Context/SuppliersContext';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { getSupplierResource } from 'Utils/suppliersResources';
import { useContext } from 'react';

interface ITraining {
  academicDegreeId?: number;
}

export const Training = ({ academicDegreeId }: ITraining) => {
  const { resources } = useContext(SuppliersContext);
  const isDesktop = useIsDesktop();

  return (
    <Stack gap='8px'>
      <Typography variant={isDesktop ? 'body2' : 'body1'}>
        {Dictionary[DICTIONARY.Suppliers].resultPage.therapy.training}
      </Typography>
      <Typography variant='body3'>
        {getSupplierResource(resources.TOARA, academicDegreeId)}
      </Typography>
    </Stack>
  );
};
